/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useState } from 'react'

interface WidgetSiteContextType {
  siteId: string
  siteName: string
  setSite: (id: string, name: string) => void
}

const WidgetSiteContext = createContext<WidgetSiteContextType | null>(null)

export const useWidgetSite = () => {
  const ctx = useContext(WidgetSiteContext)
  if (!ctx) throw new Error('useWidgetSite must be used within WidgetSiteProvider')
  return ctx
}

export const WidgetSiteProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [siteId, setSiteId] = useState(() => localStorage.getItem('wm_site_id') || '')
  const [siteName, setSiteName] = useState(() => localStorage.getItem('wm_site_name') || '')

  const setSite = (id: string, name: string) => {
    setSiteId(id)
    setSiteName(name)
    localStorage.setItem('wm_site_id', id)
    localStorage.setItem('wm_site_name', name)
  }

  return (
    <WidgetSiteContext.Provider value={{ siteId, siteName, setSite }}>
      {children}
    </WidgetSiteContext.Provider>
  )
}
